import { ArrowRight, Play } from "lucide-react"
import { Link } from "react-router-dom"

export default function Hero() {
  return (
    <section className="pt-24 pb-12 bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 rounded-full text-sm font-medium">
                🚀 Multi-tenant accounting made simple
              </div>
              <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white leading-tight">
                Your Digital
                <span className="text-blue-600"> Accountant</span>
                <br />
                in the Cloud
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed">
                Manage multiple businesses, automate reports, and track finances with ease. Accurix is the all-in-one
                accounting SaaS built for modern startups and growing businesses.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/register" className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all duration-200 flex items-center justify-center group">
                Start Free Trial
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to="/register" className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-8 py-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-center justify-center">
                <Play className="mr-2 h-5 w-5" />
                Watch Demo
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-3 sm:gap-6 text-sm text-gray-500 dark:text-gray-400">
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                14-day free trial
              </div>
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                No credit card required
              </div>
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                Cancel anytime
              </div>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-4 sm:p-6 border dark:border-gray-700">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Financial Overview</h3>
                  <div className="text-sm text-gray-500 dark:text-gray-400">This Month</div>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <div className="text-sm text-green-700 font-medium">Revenue</div>
                    <div className="text-2xl font-bold text-green-900">₦24,780.00</div>
                    <div className="text-sm text-green-600">+12% from last month</div>
                  </div>

                    <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                      <div className="text-sm text-red-700 font-medium">Expenses</div>
                      <div className="text-2xl font-bold text-red-900">₦18,230.00</div>
                      <div className="text-sm text-red-600">-5% from last month</div>
                    </div>

                  <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <div className="text-sm text-blue-700 font-medium">Net Profit</div>
                    <div className="text-2xl font-bold text-blue-900">₦6,550.00</div>
                    <div className="text-sm text-blue-600">+26% from last month</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 bg-blue-600 text-white p-2 sm:p-3 rounded-full hidden sm:block">
              <span className="text-xs sm:text-sm font-medium">Live Data</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
